import Vue from "vue";

/** For display discount codes, special promos and other information on the subscription modal. */

const getDefaultState = () => {
  return {
    reachedMaxFreeSessions: false,
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  setReachedMaxFreeSessions(newValue) {
    state.reachedMaxFreeSessions = newValue;
  },
};

const SubscriptionStore = {
  state,
  methods,
};
export default SubscriptionStore;
